export const enum EnumTelaProduto {
    Categoria = 1,
    Codigo = 2,
    Produto = 3,
    Preco = 4,
    Tributacao = 5,
    Imagem = 6,
    Revisao = 7
}